import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";

import { Helmet } from "react-helmet";

const PrivacyPolicy = () => {
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1, // Delay for each letter
        type: "spring",
        stiffness: 120,
      },
    }),
  };
  const headingText = "Benefits of Membership ";

  const title = "Privacy Policy";

  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: {
        delay: index * 0.1, // Delay each letter animation
        duration: 0.4,
        ease: "easeInOut",
      },
    }),
  };
  return (
    <div>
      <Helmet>
        {/* Basic Meta Tags */}
        <title> Privacy Policy | MSB Association</title>
        <meta
          name="description"
          content="Read our Privacy Policy for details on data collection, usage, and your rights as a valued member. "
        />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="Privacy Policy | MSB Association " />
        <meta
          property="og:description"
          content="Read our Privacy Policy for details on data collection, usage, and your rights as a valued member. "
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
================================================== */}
        <section
          id="Privacy Policy"
          className="page_header text-center  section_decoration overflow-hidden"
          style={{ background: "#333" }}
        >
          <div className="container">
  <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{
                display: "flex",
                flexDirection: "column", // stack lines vertically
                alignItems: "center",
                textAlign: "center",
                flexWrap: "wrap",
              }}
            >
              {title
                .replace(/\/n/g, "\n") // Convert "/n" to actual line breaks
                .split("\n")
                .map((line, lineIndex) => (
                  <div
                    key={`line-${lineIndex}`}
                    style={{
                      display: "flex",
                      flexWrap: "wrap", // ensure words wrap on smaller screens
                      justifyContent: "center",
                    }}
                  >
                    {line.split("").map((letter, charIndex) => {
                      const uniqueIndex = lineIndex * 30 + charIndex;
                      return (
                        <motion.span
                          key={`char-${lineIndex}-${charIndex}`}
                          custom={uniqueIndex}
                          initial="hidden"
                          animate="visible"
                          variants={letterVariants}
                          style={{
                            display: "inline-block",
                            marginRight: letter === " " ? "0.3rem" : "0",
                            whiteSpace: "pre",
                          }}
                        >
                          {letter}
                        </motion.span>
                      );
                    })}
                  </div>
                ))}
            </motion.h1>

            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li className="mb-2 mt-2">
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">Privacy Policy</a>
              </li>
            </ul>
          </div>
        </section>
        {/* Page Header - End
================================================== */}
        {/* Contact Section - Start
================================================== */}
        <section className="contact_section section_space bg-dark">
          <div className="container">
            <div className="item_details_content p-3">
              {/* <h2 className="item_details_heading" id="RegulatoryComplianceSupport">
              {headingText.split("").map((char, i) => (
              <motion.span
                key={`${char}-${i}`}
                custom={i}
                initial="hidden"
                animate="visible"
                variants={headingVariants}
              >
                {char}
              </motion.span>
            ))}
              </h2> */}
              {/* <p >
    Becoming a member of the MSB Association offers numerous advantages that can help your Money Service Business thrive in a competitive environment. Here are some key benefits:
    </p> */}

              <h5 className="mb-3">Introduction</h5>
              <p>
                The MSB Association (&quot;we&quot;, &quot;us&quot;, or
                &quot;our&quot;) is committed to protecting and respecting your
                privacy. This Privacy Policy explains how we collect, use,
                disclose, and safeguard your information when you visit our
                website or engage with our services.
              </p>
              <h5 className="mb-3">Information We Collect</h5>
              <p className="mb-2">
                We may collect and process the following data about you:
              </p>
              <ul
                className="mb-3 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">
                  Personal Identification Information: Name, email address,
                  phone number, and other contact details.
                </li>
                <li className="mb-2 mt-2">
                  Services Information: Information related to your services.
                </li>
                <li className="mb-2 mt-2">
                  Usage Data: Information about how you use our website and
                  services.
                </li>
                <li className="mb-2 mt-2">
                  Marketing and Communications Data: Your preferences in
                  receiving marketing from us and your communication
                  preferences.
                </li>
              </ul>
              <h5>How We Use Your Information</h5>
              <h6 className="mb-4 mt-4">
                We use the information we collect in the following ways:
              </h6>
              <ul
                className="mb-3 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">
                  To provide, operate, and maintain our services.
                </li>
                <li className="mb-2 mt-2">
                  To understand and analyse how you use our services.
                </li>
                <li className="mb-2 mt-2">
                  To communicate with you, either directly or through one of our
                  partners, including for customer service, to provide you with
                  updates and other information relating to the website, and for
                  marketing and promotional purposes.
                </li>
                <li className="mb-2 mt-2">To find and prevent fraud.</li>
              </ul>
              <h5 className="mb-3">Legal Basis for Processing Personal Data</h5>
              <h6 className="mb-4 mt-4">
                We will process your personal data based on the following legal
                grounds:
              </h6>
              <ul
                className="mb-3 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">
                  Consent: You have given consent for us to process your
                  personal data for a specific purpose.
                </li>
                <li className="mb-2 mt-2">
                  Legal Obligation: Processing is necessary for compliance with
                  a legal obligation.
                </li>
                <li className="mb-2 mt-2">
                  Legitimate Interests: Processing is necessary for our
                  legitimate interests, provided that your interests and
                  fundamental rights do not override those interests.
                </li>
              </ul>

              <h5>Data Sharing and Disclosure</h5>
              <h6 className="mb-4 mt-4">We may share your information with:</h6>
              <ul
                className="mb-3 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">
                  Service providers who perform services on our behalf.
                </li>
                <li className="mb-2 mt-2">
                  Regulatory authorities as required by law.
                </li>
                <li className="mb-2 mt-2">
                  Business partners for joint marketing initiatives.
                </li>
              </ul>

              <h5>Data Security</h5>
              <p>
                We take the security of your personal data seriously. We have
                implemented appropriate technical and organisational measures to
                protect your personal data from unauthorized access, use, or
                disclosure.
              </p>

              <h5>Your Rights</h5>
              <h6 className="mb-4 mt-4">
                You have the following rights regarding your personal data:
              </h6>
              <ul
                className="mb-4 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">
                  The right to access – You have the right to request copies of
                  your personal data.
                </li>
                <li className="mb-2 mt-2">
                  The right to rectification – You have the right to request
                  that we correct any information you believe is inaccurate.
                </li>
                <li className="mb-2 mt-2">
                  The right to erasure – You have the right to request that we
                  erase your personal data, under certain conditions.
                </li>
                <li className="mb-2 mt-2">
                  The right to restrict processing – You have the right to
                  request that we restrict the processing of your personal data,
                  under certain conditions.
                </li>
                <li className="mb-2 mt-2">
                  The right to data portability – You have the right to request
                  that we transfer the data that we have collected to another
                  organization, or directly to you, under certain conditions.
                </li>
              </ul>
              <h5>Changes to This Privacy Policy</h5>
              <p>
                We may update our Privacy Policy from time to time. We will
                notify you of any changes by posting the new Privacy Policy on
                this page. You are advised to review this Privacy Policy
                periodically for any changes.
              </p>
              <br />
              <h5>Contact Us</h5>
              <h6 className="mb-4 mt-4">
                If you have any questions about this Privacy Policy, please
                contact us:
              </h6>
              <ul
                className="mb-3 mt-3"
                style={{ fontSize: "18px", fontWeight: "600" }}
              >
                <li className="mb-2 mt-2">
                  Email:{" "}
                  <a href="mailto:info@msbassociationuk.org">
                    info@msbassociationuk.org
                  </a>
                </li>
                <li className="mb-2 mt-2">
                  Address: 85 Marlyon Road, Ilford, Essex, United Kingdom, IG6
                  3XW
                </li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default PrivacyPolicy;
